module.exports = __webpack_public_path__ + "media/images/cat-3deee450836d9e6edf080193c66796f2.svg";